var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Transfer',{staticClass:"customer-transfer",attrs:{"data-source":_vm.adaptedCustomers,"target-keys":_vm.targetKeys,"show-search":"","render":function (ref) {
	var title = ref.title;

	return title;
},"filter-option":_vm.filter},on:{"change":_vm.handleChange}})}
var staticRenderFns = []

export { render, staticRenderFns }